import axios, { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { Address } from '@thirdweb-dev/sdk';
import { Mode } from '@thirdweb-dev/chains';
import { useConfig } from '@app/config';
import { ApplicationConfig } from '@app/config/types';
import { useSupportedChain } from '@app/hooks/other/useSupportedChain';

export type VaultApr = {
  apr: number;
  message: 'running';
};

async function fetcher(
  vaultAddress: Address | null | undefined,
  config: ApplicationConfig | undefined,
  chainId: number | undefined
) {
  if (!vaultAddress || !chainId) {
    return null;
  }

  const { data } = await axios.get<void, AxiosResponse<VaultApr>>(
    `${config?.URLS.steerApiUrl}/pool/fee-apr?address=${vaultAddress}&chain=${chainId}&interval=604800`
  );

  return data;
}

export function useVaultApr(vaultAddress: Address | undefined | null) {
  const config = useConfig();
  const chain = useSupportedChain();

  return useQuery(
    [QueryKeys.VAULT_APR, vaultAddress, chain?.chainId],
    () => {
      return fetcher(vaultAddress, config, chain?.chainId);
    },
    {
      enabled: !!(config && chain)
    }
  );
}
